import { useEffect, useState } from 'react';

import { useAppActive } from './useAppActive';

// Live 1s tick. `visible` gates the interval so it only runs while the
// consumer actually needs a live clock (a modal that's open, an
// unfinished workout's elapsed-time counter, ...) — a single shared
// primitive so every "tick every second while X" surface uses the SAME
// setInterval/cleanup instead of re-rolling it per callsite (CN-11).
// Moved here from apps/mobile/src/logger/useNowTick.ts, which was deleted
// (no re-export shim: both consumers import from @heraion/ui).
// Originally extracted verbatim out of LoggerScreen body (Track R); kept
// bit-identical through the move.
// #325: no tick in background; the clock is re-read when the tick restarts.
export function useNowTick(visible: boolean): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  const active = useAppActive();
  useEffect(() => {
    if (!visible || !active) return undefined;
    setNowMs(Date.now());
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, [visible, active]);
  return nowMs;
}
